import type { SupportedLanguage } from '../i18n'

/**
 * 检测浏览器语言并匹配支持的语言
 */
export const detectBrowserLanguage = (): SupportedLanguage => {
  const browserLang = navigator.language.toLowerCase()
  
  // 中文
  if (browserLang.startsWith('zh')) {
    return 'zh-CN'
  }
  
  // 法语
  if (browserLang.startsWith('fr')) {
    return 'fr'
  }
  
  // 德语
  if (browserLang.startsWith('de')) {
    return 'de'
  }
  
  // 默认英语
  return 'en'
}

/**
 * 从 URL 参数获取语言设置
 */
export const getLanguageFromURL = (): SupportedLanguage | null => {
  const urlParams = new URLSearchParams(window.location.search)
  const lang = urlParams.get('lang')
  
  if (lang && ['en', 'zh-CN', 'fr', 'de'].includes(lang)) {
    return lang as SupportedLanguage
  }
  
  return null
}

/**
 * 从 localStorage 获取保存的语言设置
 */
export const getSavedLanguage = (): SupportedLanguage | null => {
  const saved = localStorage.getItem('preferred-language')
  
  if (saved && ['en', 'zh-CN', 'fr', 'de'].includes(saved)) {
    return saved as SupportedLanguage
  }
  
  return null
}

/**
 * 获取初始语言设置（优先级：URL参数 > localStorage > 浏览器语言 > 默认英语）
 */
export const getInitialLanguage = (): SupportedLanguage => {
  return getLanguageFromURL() || getSavedLanguage() || detectBrowserLanguage() || 'en'
}

/**
 * 更新 URL 语言参数（不刷新页面）
 */
export const updateURLLanguage = (lang: SupportedLanguage): void => {
  const url = new URL(window.location.href)
  url.searchParams.set('lang', lang)
  window.history.replaceState({}, '', url.toString())
}
